import React, { useMemo } from 'react';
import './SpeedLines.css';

function SpeedLines() {
  const lines = useMemo(() =>
    Array.from({ length: 20 }).map((_, i) => ({
      id: i,
      top: 10 + Math.random() * 80,
      width: 30 + Math.random() * 120,
      delay: Math.random() * 3,
      duration: 0.5 + Math.random() * 1,
      opacity: 0.03 + Math.random() * 0.08,
    })), []);

  return (
    <div className="speed-lines">
      {lines.map(l => (
        <div
          key={l.id}
          className="speed-line"
          style={{
            top: `${l.top}%`,
            width: l.width,
            animationDelay: `${l.delay}s`,
            animationDuration: `${l.duration}s`,
            opacity: l.opacity,
          }}
        />
      ))}
    </div>
  );
}

export default SpeedLines;
